import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Observable, PureComputed } from 'knockout';
import ThreadEditorVM from './thread';
import ThreadEditorParticipantsPickerVM from './participantsPicker';
import ThreadEditorVisibilityTagsPickerVM from './visibilityTagsPicker';
import './visibilityOptions.html';
import './visibilityOptions.scss';

export interface ThreadEditorVisibilityOptionsVMConfig {
    editor: ThreadEditorVM
}

@injectable()
export default class ThreadEditorVisibilityOptionsVM {
    editor: ThreadEditorVM

    participantsPicker: Observable<ThreadEditorParticipantsPickerVM | undefined> = ko.observable()
    visibilityTagsPicker: Observable<ThreadEditorVisibilityTagsPickerVM | undefined> = ko.observable()

    isVisible: PureComputed<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: ThreadEditorVisibilityOptionsVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.editor = config.editor;

        this.isVisible = ko.pureComputed(() => this.participantsPicker()?.isVisible() || this.visibilityTagsPicker()?.isVisible() || false);

        ko.applyBindingsToNode(info.element, {
            'visible': this.isVisible,

            'css': {
                'thread-editor-visibility-options': true
            }
        }, this);
    }
}